import React, { ReactNode, useContext, useMemo, useState, useEffect } from 'react';
import { IBranchViewModel } from 'viewModels';
import { useQuery } from 'react-query';
import { CompanyController } from '../controller/CompanyController';
import { useAuth } from './auth';

type BranchContextProps = {
  children: ReactNode;
};
interface IInitialValues {
  branches: IBranchViewModel[];
  setBranches: React.Dispatch<React.SetStateAction<IBranchViewModel[]>>;
  isLoadingBranches: boolean;
}
const BranchContext = React.createContext({} as IInitialValues);

const BranchProvider = ({ children }: BranchContextProps) => {
  const { user, tokenIsValid } = useAuth();
  const [branches, setBranches] = useState<IBranchViewModel[]>([]);

  const { isLoading: isLoadingBranches } = useQuery(
    'branch',
    () => CompanyController.getBranchesByUserId(user.id),
    {
      onSuccess: (data) => {
        setBranches(data);
      },
      refetchOnWindowFocus: false,
      enabled: !!user.id && tokenIsValid,
    },
  );

  useEffect(() => {
    if (!tokenIsValid) {
      setBranches([]);
    }
  }, [tokenIsValid]);

  const contextValues = useMemo(
    () => ({ branches, setBranches, isLoadingBranches }),
    [branches, isLoadingBranches],
  );

  return <BranchContext.Provider value={contextValues}>{children}</BranchContext.Provider>;
};
export const useBranch = () => useContext(BranchContext);
export default BranchProvider;
